<table class="table table-responsive align-middle collapsable-table" [attr.id]="'' + refid" [ngClass]="custom">
  <thead>
  <tr>
    <ng-content *ngTemplateOutlet="headerTemplate"></ng-content>
  </tr>
  </thead>
  <tbody>
  <ng-container *ngFor="let item of items; let id = index">
    <tr>
      <ng-content *ngTemplateOutlet="firstTemplate; context: { $implicit: item, index: id, refid: refid }"></ng-content>
    </tr>
    <tr>
      <td [attr.colspan]="colspan" class="p-0">
        <div [attr.id]="'item' + refid + id" [attr.data-bs-parent]="'#' + refid" class="collapse">
          <ng-content *ngTemplateOutlet="secondTemplate; context: { $implicit: item }"></ng-content>
        </div>
      </td>
    </tr>
  </ng-container>
  </tbody>
</table>
